import { render, staticRenderFns } from "./OpenGraphRichArgument.vue?vue&type=template&id=6961e357"
import script from "./OpenGraphRichArgument.vue?vue&type=script&lang=js"
export * from "./OpenGraphRichArgument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports